{
    "reorders__empty_title": "Aucune recommandation pour ce client",
    "reorders__empty_body": "Vous trouverez ici les articles dont le client pourrait bientôt avoir de nouveau besoin.",

    "modal_title": "Sélectionner une variante d'article",
    "search_variants_placeholder": "Rechercher des articles, etc.",

    "table_header__article_id": "ID article",
    "table_header__article_name": "Article",
    "table_header__last_quantitiy": "Quantité commandée",
    "table_header__last_order_date": "Dernière commande",

    "submit_button": "Ajouter l'article"
}
